import { Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={3}>
		<Text semiBold text="normal" />
		<Text semiBold text="lowercase" />
		<Text semiBold text="uppercase" />
		<Text text="Centric Software" />
		<Text lowercase text="Centric Software" />
		<Text text="Centric Software" uppercase />
	</CssColumnGrid>
);
